// Sidenav.tsx — Primary navigation. Active item derived from the
// current pathname (React Router's useLocation), with the same
// sub-route mapping the vanilla scaffold used: any /license-orgs/*
// path lights up the "License Orgs" item.

import { Link, useLocation } from 'react-router-dom';

interface NavItem {
  key: string;
  label: string;
  icon: string;
  to: string;
}

const NAV_ITEMS: NavItem[] = [
  { key: 'license-orgs', label: 'License Orgs', icon: 'groups', to: '/license-orgs' },
  { key: 'unlock-codes', label: 'Unlock Codes', icon: 'vpn_key', to: '/unlock-codes' },
  { key: 'settings', label: 'Settings', icon: 'tune', to: '/settings' },
];

function activeKeyForPath(pathname: string): string | null {
  if (pathname.startsWith('/license-orgs')) return 'license-orgs';
  if (pathname.startsWith('/unlock-codes')) return 'unlock-codes';
  if (pathname.startsWith('/settings')) return 'settings';
  return null;
}

export function Sidenav() {
  const { pathname } = useLocation();
  const activeKey = activeKeyForPath(pathname);
  return (
    <nav className="console-sidenav" aria-label="Primary">
      <div className="console-sidenav-eyebrow">Manage</div>
      {NAV_ITEMS.map((item) => {
        const isActive = item.key === activeKey;
        return (
          <Link
            key={item.key}
            to={item.to}
            data-nav-key={item.key}
            className={
              'console-nav-item' + (isActive ? ' is-active' : '')
            }
          >
            <span className="material-icons console-nav-icon">{item.icon}</span>
            <span className="console-nav-label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
